var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGmail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4298 9.05563L17.0685 14.0201L10.5618 9.05563V9.05697L10.5696 9.06369V16.0153L16.9952 21.087L23.4298 16.2111V9.05563Z",
    fill: "#EA4335"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0995 7.84804L23.429 9.0556V16.2111L28.6857 12.1752V9.74391C28.6857 9.74391 28.0476 6.27149 25.0995 7.84804Z",
    fill: "#FBBC05"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.429 16.2111V25.4919H27.458C27.458 25.4919 28.6045 25.3739 28.6869 24.067V12.1752L23.429 16.2111Z",
    fill: "#34A853"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5703 25.5001V16.0153L10.5618 16.0086L10.5703 25.5001Z",
    fill: "#C5221F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5614 9.0568L8.89999 7.85594C5.9519 6.27939 5.3125 9.75048 5.3125 9.75048V12.1817L10.5614 16.0084V9.0568Z",
    fill: "#C5221F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5618 9.05719V16.0088L10.5703 16.0155V9.0639L10.5618 9.05719Z",
    fill: "#C5221F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3125 12.1835V24.0753C5.39374 25.3835 6.54153 25.5003 6.54153 25.5003H10.5706L10.5614 16.0088L5.3125 12.1835Z",
    fill: "#4285F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGmail);
export default __webpack_public_path__ + "static/media/icon_gmail.dbf6bdd21d8e2ef0a4ca2eee1becdee1.svg";
export { ForwardRef as ReactComponent };